export const preloadModals = (): void => {
  import('@/app/components/Modal/StepModal');
  import('@/app/components/Modal/SequentialStepModal');
  import('@/app/components/Modal/DepositStepperModal');
  import('@/app/components/Modal/TransactionCompleted');
};